export const experienceFormSubject = {
  APPOINTMENT_REQUEST: 'APPOINTMENT_REQUEST',
  OTHERS: 'OTHERS',
  PRIVATE_GROUP: 'PRIVATE_GROUP',
  QUESTION_ABOUT_EXPERIENCE: 'QUESTION_ABOUT_EXPERIENCE',
} as const

export type ExperienceFormSubject = keyof typeof experienceFormSubject
